import React from 'react'

import Icon from '@/components/common/Icon'

const IconDelivery: React.FC<{
  className?: string
  width?: number
  height?: number
}> = ({ className, width, height }) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 48 44"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M38 30C35.6 30 33.4833 29.25 31.65 27.75C29.8167 26.25 28.6667 24.3333 28.2 22H22.25L19.85 18H28.2C28.3667 17.2667 28.5917 16.5667 28.875 15.9C29.1583 15.2333 29.5333 14.6 30 14H17.4L15 10H32.1L29.9 4H22V0H29.9C30.7667 0 31.5333 0.241667 32.2 0.725C32.8667 1.20833 33.35 1.85 33.65 2.65L36.35 10H38C40.7667 10 43.125 10.975 45.075 12.925C47.025 14.875 48 17.2333 48 20C48 22.7667 47.025 25.125 45.075 27.075C43.125 29.025 40.7667 30 38 30ZM38 26C39.6667 26 41.0833 25.4167 42.25 24.25C43.4167 23.0833 44 21.6667 44 20C44 18.3333 43.4167 16.9167 42.25 15.75C41.0833 14.5833 39.6667 14 38 14H37.85L39.8 19.35L36 20.7L34.1 15.45C33.4333 16.0167 32.9167 16.7 32.55 17.5C32.1833 18.3 32 19.1333 32 20C32 21.6667 32.5833 23.0833 33.75 24.25C34.9167 25.4167 36.3333 26 38 26ZM14 44C12.3333 44 10.9167 43.4167 9.75 42.25C8.58333 41.0833 8 39.6667 8 38H0V34H9.55C10.05 33.5 10.6833 33.0417 11.45 32.625C12.2167 32.2083 13.0667 32 14 32C14.8333 32 15.6333 32.1667 16.4 32.5C17.1667 32.8333 17.85 33.3333 18.45 34H24V30H0V26H4V20H0V16H14L20 26H24C25.1 26 26.0417 26.3917 26.825 27.175C27.6083 27.9583 28 28.9 28 30V34C28 35.1 27.6083 36.0417 26.825 36.825C26.0417 37.6083 25.1 38 24 38H20C20 39.6667 19.4167 41.0833 18.25 42.25C17.0833 43.4167 15.6667 44 14 44ZM8 26H15.35L11.75 20H8V26ZM14 40C14.5667 40 15.0417 39.8083 15.425 39.425C15.8083 39.0417 16 38.5667 16 38C16 37.4333 15.8083 36.9583 15.425 36.575C15.0417 36.1917 14.5667 36 14 36C13.4333 36 12.9583 36.1917 12.575 36.575C12.1917 36.9583 12 37.4333 12 38C12 38.5667 12.1917 39.0417 12.575 39.425C12.9583 39.8083 13.4333 40 14 40Z"
      fill="currentColor"
    />
  </svg>
)

export default Icon(IconDelivery)
